export default "__VITE_ASSET__BJgDdy2B__"